export enum MusicCode {
  MAIN_TITLE = "MAIN_TITLE",
  VISUAL_INSTRUMENTAL = "VISUAL_INSTRUMENTAL",
  BACKGROUND_VOCAL = "BACKGROUND_VOCAL",
  VISUAL_VOCAL = "VISUAL_VOCAL",
  END_TITLE = "END_TITLE",
  BACKGROUND_INSTRUMENTAL = "BACKGROUND_INSTRUMENTAL",
  THEME = "THEME",
}

export interface MusicCueSheet {
  id?: string;
  title: string;
  code: string;
  startTime: string;
  endTime: string;
  composers: string;
  publishers: string;
  performers: string;
  recordLabel: string;
}